module.exports = __webpack_public_path__ + "img/close-brothers.0d427cf5.svg";